import Container from '@components/components/Container/Container';
import styles from '@components/components/Footer/Footer.module.scss';
import logoStadtwerke from '@components/images/logo-stadtwerke.include.svg';
import { usePageData } from '@components/context';
import React, { useEffect } from 'react';
import { useTranslation } from '@wienenergiegithub/modules-next/hooks';
import classNames from 'classnames';
import {
  Content,
  FontAwesomeProIcon,
  Image,
  Link,
} from '@wienenergiegithub/ui-next';
import {
  useDisclosureStore,
  Disclosure,
  DisclosureContent,
} from '@ariakit/react';

const Footer = () => {
  const { socialMenu, footerMenuQuick, footerAssociates, footerLegalMenu } =
    usePageData();
  const disclosure = useDisclosureStore();
  const { open } = disclosure.useState();
  const { t } = useTranslation('footer');
  useEffect(() => {
    if (open) {
      window.scroll({
        top: document.body.scrollHeight,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [open]);

  return (
    <footer className={styles.container} id="page-footer">
      <Container>
        <div className={styles.inner}>
          <nav aria-label="Inhaltsangabe" className={styles.metaMenuContainer}>
            <ul className={styles.metaMenu}>
              {footerMenuQuick &&
                footerMenuQuick.map(item => (
                  <li className={styles.metaGroup} key={item.id}>
                    <Link className={styles.quickTitle} to={item.url}>
                      {item.title}
                    </Link>
                    <ul className={styles.quickContainer}>
                      {item?.children?.map(child => (
                        <li key={child.url}>
                          <Link className={styles.innerItem} to={child.url}>
                            {child.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
            </ul>
          </nav>
          <div className={styles.socialLegalWrapper}>
            <nav aria-label="Soziale Netzwerke" id="social-nav">
              <ul className={styles.socialMenu}>
                {socialMenu.map(({ iconName, iconType, id, url, title }) => (
                  <li className={styles.socialMenuItem} key={id}>
                    <Link
                      aria-label={title}
                      className={styles.socialMenuLink}
                      data-purpose={title}
                      rel="nofollow noopener"
                      target="_blank"
                      to={url}
                    >
                      <FontAwesomeProIcon
                        className={styles.socialMenuIcon}
                        fixedWidth
                        icon={iconName}
                        role="presentation"
                        type={iconType}
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
            {footerLegalMenu.length !== 0 && (
              <nav aria-label="Legal Menu" id="legal-nav">
                <ul className={styles.footerLegalMenu}>
                  {footerLegalMenu?.map(item => (
                    <li className={styles.legalMenuItem} key={item.id}>
                      <Link className={styles.legalItem} to={item.url}>
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            )}
          </div>
        </div>
      </Container>
      <div className={styles.legalWrapper}>
        <Container>
          <div className={styles.legal}>
            <Content as="div" className={styles.copyright} size="regular">
              © {new Date().getFullYear()} Wien Energie GmbH | Wien Energie
              Vertrieb GmbH & Co KG
            </Content>
            <div className={styles.disclosureWrapper}>
              <Content
                className={classNames(
                  styles.disclosureToggle,
                  styles.upperLine,
                )}
                size="regular"
              >
                {t('line1')}
              </Content>
              <Disclosure
                className={styles.disclosureToggle}
                render={
                  <div>
                    <Content
                      as="div"
                      className={styles.lowerLine}
                      size="regular"
                    >
                      {t('line2')}
                    </Content>
                    <FontAwesomeProIcon
                      className={classNames(styles.arrow, {
                        [styles.accordionOpen]: open,
                      })}
                      icon="chevron-down"
                      role="presentation"
                    />
                  </div>
                }
                store={disclosure}
              />
            </div>
          </div>
        </Container>
      </div>
      <DisclosureContent store={disclosure}>
        <aside aria-label="Wiener Stadtwerke" className={styles.full}>
          <Container className={styles.fullContainer}>
            <div>
              <Image
                alt="Wiener Stadtwerke Logo"
                className={styles.groupLogo}
                src={logoStadtwerke}
              />
              <Content size="regular">{t('description')}</Content>
            </div>
            <div>
              <Content
                as={Link}
                className={styles.weGroupName}
                href="https://www.wienerstadtwerke.at"
                size="md"
              >
                www.wienerstadtwerke.at
              </Content>
              <div>
                <ul className={styles.network} id="network-links">
                  {footerAssociates &&
                    footerAssociates.map(item => (
                      <li key={item.url}>
                        <Link
                          className={styles.menuItem}
                          href={item.url}
                          rel="nofollow noopener"
                        >
                          {item.title}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </Container>
        </aside>
      </DisclosureContent>
    </footer>
  );
};

export default Footer;
